import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useSite(env) {
  const [site, setSite] = useState(null);
  useEffect(() => {
    setSite(null);
    api.get("/site", { params: { env } }).then((r) => setSite(r.data)).catch(() => setSite(false));
  }, [env]);
  return site;
}

export function usePage(slug, env) {
  const [page, setPage] = useState(null);
  useEffect(() => {
    setPage(null);
    api.get(`/pages/${slug}`, { params: { env } }).then((r) => setPage(r.data)).catch(() => setPage(false));
  }, [slug, env]);
  return page;
}
